module.exports = __webpack_public_path__ + "static/img/accountAccessPic.344f263.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/accountAccessPic.png
// module id = Zdwm
// module chunks = 1